import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { SelectionService } from '../../../models/review/selection-service';
import { OkCancelDialogComponent } from '../../dialogs/ok-cancel/ok-cancel-dialog.component';
import { UserConfigsService } from 'src/app/services/user-configs.service';
import { Role } from 'src/app/models/role.model';
import { SearchParameter } from '../../../models/review/search-parameter.model';
import { BulkDeleteDocsSdk } from '@sdks/bulk-delete-docs.sdk';
import { BulkDocDeletePayload } from '@models/review/bulk-doc-delete-payload.model';

@Component({
    selector: 'lex-delete-docs',
    templateUrl: './delete-docs.component.html',
    styleUrls: ['./delete-docs.component.scss'],
    standalone: false
})
export class DeleteDocsComponent {
  @Input() searchParameter: SearchParameter;
  @Output() reload = new EventEmitter();

  private lifecycleId: string = 'B0E5DF1C-CD09-45AD-BBC9-ED9DAD1CB053';
  Role = Role;

  constructor(public selectionService: SelectionService, private bulkDeleteDocsSdk: BulkDeleteDocsSdk, private dialog: MatDialog, public ucs: UserConfigsService) { }

  deleteSelected() {
    this.selectionService.operationAlert = null;
    const dialogConfig = new MatDialogConfig();
    dialogConfig.autoFocus = true;
    dialogConfig.data = {
      title: `Delete Document Confirmation`,
      message: `Total Docs Selected: ${this.selectionService.SelectedCount}
        <br /> Delete Documents?
        <br /> These documents including any/all related email family members will be PERMANENTLY DELETED from the entire case.
        <br /> This action cannot be undone.`
    };
    dialogConfig.panelClass = "add-docs-to-job-panel";

    this.dialog.open(OkCancelDialogComponent, dialogConfig).afterClosed().subscribe((okClicked: boolean) => {
      if (okClicked)
        this.postMultiDoc();
    });
  }

  postMultiDoc() {
    const payload: BulkDocDeletePayload = new BulkDocDeletePayload();
    payload.expandEmailFamily = true;
    payload.filterId = this.selectionService.getSavedFilterId();
    payload.docIds = this.selectionService.selection.selected.map(s => s.docId);
    payload.selectAll = this.selectionService.selectAllFlag;
    payload.searchParameter = this.searchParameter;
    this.bulkDeleteDocsSdk.deleteDocs(payload)
      .subscribe(isSuccess => {
        if (isSuccess) {
          this.reload.emit();
          this.selectionService.operationAlert = 'The documents are being deleted. This may take a few moments.';
        }
      });
  }
}
